import Vue from "vue";
import moment from "moment-jalaali";

Vue.filter('timeAgo', value => moment(value).fromNow());
Vue.filter('longDate', value => moment(value).format('HH:mm jYYYY-jM-jD'));
Vue.filter('rial', value => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
Vue.filter('stringDate', function (input) {
    try {
        // let moment = require('moment-jalaali')
        moment.locale("fa", null);
        moment.loadPersian({dialect: 'persian-modern'});
        return moment(input, 'YYYY-M-D HH:mm:ss').format('dddd LL HH:mm:ss');
    } catch (e) {
    }
})

Vue.filter("currency", (x) => {
    return x ? new Intl.NumberFormat('en-US', {style: 'decimal'}).format(x) : "-";
});


Vue.filter('userType', value => {
    if (value === 'legal')
        return 'شخص حقوقی';
    return 'شخص حقیقی';
})

Vue.filter('serviceType', val => {
    if (val === 'Payamakland')
        return 'پیامک لند';
    else if(val === 'Coreland')
        return 'کورلند';
    else if(val === 'Qrland')
        return 'کیوآر لند';
    else
        return 'ربات لند'
})


Vue.filter( 'userType', value => {
    if (value === 'regular')
        return 'حقوقی';
    return 'حقیقی';
})

Vue.filter('isEmpty', value => {
    return  value ? value : ""
})

Vue.filter('persianNumber' , value=>{
    return value.toPersianLetter();
})

Vue.filter('numericPersianNumber' , value=>{
    return value / 1_000_000 + " میلیون"
})
